import { render } from "./staff_users.vue?vue&type=template&id=0b7ccf41&scoped=true"
import script from "./staff_users.vue?vue&type=script&lang=js"
export * from "./staff_users.vue?vue&type=script&lang=js"

import "./staff_users.vue?vue&type=style&index=0&id=0b7ccf41&scoped=true&lang=css"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7ccf41"]])

export default __exports__